import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Storefront from "@/pages/Storefront";
import Admin from "@/pages/Admin";
import ProductPage from "@/pages/ProductPage";
import { CartProvider } from "@/context/CartContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { FavoritesProvider } from "@/context/FavoritesContext";

function App() {
  return (
    <BrowserRouter>
      <SettingsProvider>
      <CartProvider>
      <FavoritesProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Storefront />} />
          <Route path="/producto/:code" element={<ProductPage />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </FavoritesProvider>
      </CartProvider>
      </SettingsProvider>
    </BrowserRouter>
  );
}

export default App;
